import { ListWithPagination } from '@anytag/shared-molecules';
import { useYoutubeCmsInvoiceListQuery } from '@anytag/graphql';
import { getOffset, getValuableVariables } from '@anytag/shared-utils';
import { useUpdateDocumentTitle } from '@anytag/shared-hooks';
import {
  YoutubeCMSDescription,
  YoutubeCMSInvoicesList,
  YoutubeCMSInvoicesHeader,
  YoutubeCMSInvoicesFilter,
  useYoutubeCMSInvoicesFilter
} from '@anytag/shared-organisms';

export const YoutubeCMSInvoices = () => {
  useUpdateDocumentTitle({ title: 'documentTitle.YoutubeCMSInvoices', appHeader: 'appHeader.YoutubeCMSInvoices' });
  const {
    page,
    limit,
    filter: { keyword, month }
  } = useYoutubeCMSInvoicesFilter();
  const { data, previousData, loading } = useYoutubeCmsInvoiceListQuery({
    skip: !month,
    fetchPolicy: 'cache-and-network',
    variables: getValuableVariables({
      limit,
      month,
      keyword,
      offset: getOffset(page, limit)
    })
  });

  const result = loading ? previousData : data;
  const totalRecords = result?.youtubeCmsInvoiceCount?.totalNumber;

  return (
    <div>
      <YoutubeCMSInvoicesHeader hasNoData={!totalRecords} />

      <YoutubeCMSDescription />

      <ListWithPagination pagination={{ totalRecords }}>
        <YoutubeCMSInvoicesFilter />
        <YoutubeCMSInvoicesList
          loading={loading}
          totalRecords={totalRecords}
          data={result?.youtubeCmsInvoiceList || []}
        />
      </ListWithPagination>
    </div>
  );
};
